import {
  Box,
  Card,
  CircularProgress,
  Grid,
  IconButton,
  Pagination,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
  Typography,
} from "@mui/material";
import LaunchIcon from "@mui/icons-material/Launch";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import useAxiosAuth from "../../../hooks/useAxiosAuth";
import NoDataFound from "../../../components/NoDataFound";
import { convertDateTimeToLocal } from "../../../utils/date-operations";

const Interviews = () => {
  const axiosAuth = useAxiosAuth();
  const navigate = useNavigate();
  const pageSize = 50;

  const [interviewDetails, setInterviewDetails] = useState();
  const [currentPage, setCurrentPage] = useState(1);

  const getInterviews = (skip) => {
    axiosAuth
      .get(
        "/api/Interviewes/GetInterviews?status=0&skip=" +
          skip +
          "&take=" +
          pageSize
      )
      .then((response) => {
        setInterviewDetails(response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    getInterviews(0);
  }, []);

  return (
    <Grid maxWidth="xl" sx={{ marginX: "auto", paddingY: 4, paddingX: 2 }}>
      <Card elevation={3}>
        <Grid
          sx={{
            background: "linear-gradient(to right,#4a7dcf 0%, #2a569f 100%)",
            paddingX: 2,
            paddingY: 1,
          }}
        >
          <Grid
            container
            direction="row"
            justifyContent="space-between"
            alignItems="center"
          >
            <Typography variant="h5" color="white.main">
              Interviews
            </Typography>
          </Grid>
        </Grid>

        <Grid container>
          {interviewDetails !== undefined && (
            <Grid item xs={12}>
              <Stack
                direction="row"
                spacing={2}
                alignItems="center"
                justifyContent="flex-end"
                sx={{ paddingX: 2, paddingTop: 2 }}
              >
                <Typography>Total: {interviewDetails.count}</Typography>
                <Pagination
                  count={Math.ceil(interviewDetails.count / pageSize)}
                  page={currentPage}
                  variant="outlined"
                  shape="rounded"
                  showFirstButton
                  showLastButton
                  color="primary"
                  onChange={(event, newPage) => {
                    setCurrentPage(newPage);
                    getInterviews((newPage - 1) * pageSize);
                  }}
                />
              </Stack>
            </Grid>
          )}

          <Grid item xs={12}>
            {interviewDetails !== undefined ? (
              interviewDetails.interviews &&
              interviewDetails.interviews.length > 0 ? (
                <Box>
                  {/* Mobile card view */}
                  <Box
                    sx={{
                      display: { xs: "flex", md: "none" },
                      flexDirection: "column",
                    }}
                  >
                    {interviewDetails.interviews.map((row) => (
                      <Card
                        key={row.id}
                        variant="outlined"
                        sx={{
                          margin: 1,
                          padding: 1,
                          display: "flex",
                          justifyContent: "space-between",
                          backgroundColor: "#F5F5F5",
                        }}
                      >
                        <Stack spacing={1} sx={{ flex: 1 }}>
                          <Typography variant="h6">
                            <b>Job:</b> {row.jobPost?.title}
                          </Typography>
                          <Typography>
                            <b>Description:</b> {row.description}
                          </Typography>
                          <Typography>
                            <b>Date & Time:</b>{" "}
                            {convertDateTimeToLocal(row.dateTime)}
                          </Typography>
                          <Typography>
                            <b>Venue:</b> {row.venue}
                          </Typography>
                          <Typography>
                            <b>Type:</b> {row.typeDisplay}
                          </Typography>
                        </Stack>
                        <Box>
                          <Tooltip title="View Job Post">
                            <IconButton
                              color="primary"
                              size="small"
                              onClick={() =>
                                navigate(
                                  "/admin/jobpost?ref=" +
                                    row.jobPostId +
                                    "&prePage=/admin/interviews"
                                )
                              }
                            >
                              <LaunchIcon fontSize="inherit" />
                            </IconButton>
                          </Tooltip>
                        </Box>
                      </Card>
                    ))}
                  </Box>

                  {/* Desktop table view */}
                  <Box sx={{ display: { xs: "none", md: "flex" } }}>
                    <TableContainer sx={{ padding: 2 }}>
                      <Table
                        sx={{
                          borderWidth: 1,
                          border: "solid",
                          borderColor: "#f2f2f2",
                        }}
                        size="small"
                      >
                        <TableHead>
                          <TableRow sx={{ backgroundColor: "#e6eeff" }}>
                            <TableCell sx={{ width: 50 }}>#</TableCell>
                            <TableCell align="left">Job Title</TableCell>
                            <TableCell align="left">Description</TableCell>
                            <TableCell align="left" sx={{ width: 170 }}>
                              Date & Time
                            </TableCell>
                            <TableCell align="left" sx={{ width: 150 }}>
                              Venue
                            </TableCell>
                            <TableCell align="left" sx={{ width: 130 }}>
                              Type
                            </TableCell>
                            <TableCell align="right" sx={{ width: 60 }} />
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {interviewDetails.interviews.map((row) => (
                            <TableRow key={row.id}>
                              <TableCell component="th" scope="row">
                                {row.index}
                              </TableCell>
                              <TableCell align="left">
                                <Typography variant="h6">
                                  {row.jobPost?.title}
                                </Typography>
                              </TableCell>
                              <TableCell align="left">
                                {row.description}
                              </TableCell>
                              <TableCell align="left">
                                {convertDateTimeToLocal(row.dateTime)}
                              </TableCell>
                              <TableCell align="left">{row.venue}</TableCell>
                              <TableCell align="left">
                                {row.typeDisplay}
                              </TableCell>
                              <TableCell align="right">
                                <Tooltip title="View Job Post">
                                  <IconButton
                                    color="primary"
                                    size="small"
                                    onClick={() =>
                                      navigate(
                                        "/admin/jobpost?ref=" +
                                          row.jobPostId +
                                          "&prePage=/admin/interviews"
                                      )
                                    }
                                  >
                                    <LaunchIcon fontSize="inherit" />
                                  </IconButton>
                                </Tooltip>
                              </TableCell>
                            </TableRow>
                          ))}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </Box>
                </Box>
              ) : (
                <Box sx={{ padding: 2 }}>
                  <NoDataFound />
                </Box>
              )
            ) : (
              <Box
                sx={{ display: "flex", justifyContent: "center", marginY: 5 }}
              >
                <Stack
                  direction="column"
                  spacing={3}
                  justifyContent="center"
                  alignItems="center"
                >
                  <Typography variant="h5" textAlign="center">
                    Loading Interview Details...
                  </Typography>
                  <CircularProgress />
                </Stack>
              </Box>
            )}
          </Grid>

          {interviewDetails !== undefined && (
            <Grid item xs={12}>
              <Box
                sx={{
                  paddingX: 2,
                  marginBottom: 2,
                  display: "flex",
                  justifyContent: "flex-end",
                }}
              >
                <Pagination
                  count={Math.ceil(interviewDetails.count / pageSize)}
                  page={currentPage}
                  variant="outlined"
                  shape="rounded"
                  showFirstButton
                  showLastButton
                  color="primary"
                  sx={{ marginTop: 2 }}
                  onChange={(event, newPage) => {
                    setCurrentPage(newPage);
                    getInterviews((newPage - 1) * pageSize);
                  }}
                />
              </Box>
            </Grid>
          )}
        </Grid>
      </Card>
    </Grid>
  );
};

export default Interviews;
